import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const SHOW_DELAY_MS = 200;

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private loadCount = 0;
    private showTimer: ReturnType<typeof setTimeout> | null = null;
    loadState: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public showLoaderBool: boolean = true;

    showLoader() {
        this.loadCount += 1;
        if (!this.showLoaderBool || this.showTimer || this.loadState.value) {
            return;
        }

        this.showTimer = setTimeout(() => {
            this.showTimer = null;
            if (this.loadCount > 0 && this.showLoaderBool) {
                this.loadState.next(true);
            }
        }, SHOW_DELAY_MS);
    }

    hideLoader() {
        this.loadCount = this.loadCount > 0 ? this.loadCount - 1 : 0;
        if (this.loadCount > 0) {
            return;
        }

        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }

        if (this.showLoaderBool) {
            this.loadState.next(false);
        }
    }
}
